export default "__VITE_ASSET__61372ce6__"